// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"39018ef8","787":"82580eac"}[chunkId] + ".chunk.js";
};